import { render, staticRenderFns } from "./myTask.vue?vue&type=template&id=6d86cf30&scoped=true"
import script from "./myTask.vue?vue&type=script&lang=js"
export * from "./myTask.vue?vue&type=script&lang=js"
import style0 from "./myTask.vue?vue&type=style&index=0&id=6d86cf30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d86cf30",
  null
  
)

export default component.exports